import { render, staticRenderFns } from "./CurrentSituationReservoirs.vue?vue&type=template&id=dec2943a&scoped=true"
import script from "./CurrentSituationReservoirs.vue?vue&type=script&lang=js"
export * from "./CurrentSituationReservoirs.vue?vue&type=script&lang=js"
import style0 from "./CurrentSituationReservoirs.vue?vue&type=style&index=0&id=dec2943a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec2943a",
  null
  
)

export default component.exports